"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Return sold hours
 * @param {string} value
 * @returns {string}
 */
const getSoldHours = (value) => {
    // fractions against their respective hours
    const soldDaysMap = {
        '0833': 1,
        '1666': 2,
        '2499': 3,
        '3332': 4,
    };
    const splitVal = `${value}`.split('.'); // gives an array
    const hours = soldDaysMap[splitVal[1]];
    return hours;
};
exports.default = getSoldHours;
